import React from "react"
import { fmt } from "../helpers/format"

const PALETTE = ["#7C5CFA", "#0891B2", "#D97706", "#059669", "#DB2777", "#2563EB", "#DC2626", "#9333EA"]

const Donut = ({ items = [], total }) => {
  const totalCents = total?.cents ?? items.reduce((acc, it) => acc + (it.value?.cents || 0), 0)
  if (!totalCents) {
    return (
      <div className="flex items-center justify-center h-44 text-[12.5px] text-slate-400">
        {I18n.t("projects.finance.no_costs")}
      </div>
    )
  }

  const radius = 56
  const circumference = 2 * Math.PI * radius
  let offset = 0

  return (
    <div className="flex items-center gap-6">
      <svg viewBox="0 0 160 160" width="160" height="160" className="-rotate-90">
        <circle cx="80" cy="80" r={radius} stroke="#F1F5F9" strokeWidth="20" fill="none" />
        {items.map((item, i) => {
          const value = item.value?.cents || 0
          if (!value) return null
          const fraction = value / totalCents
          const dash = circumference * fraction
          const seg = (
            <circle
              key={item.id}
              cx="80" cy="80" r={radius}
              stroke={PALETTE[i % PALETTE.length]}
              strokeWidth="20"
              fill="none"
              strokeDasharray={`${dash} ${circumference - dash}`}
              strokeDashoffset={-offset}
            />
          )
          offset += dash
          return seg
        })}
      </svg>
      <ul className="flex-1 space-y-1.5 text-[12px]">
        {items.map((item, i) => (
          <li key={item.id} className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ backgroundColor: PALETTE[i % PALETTE.length] }} />
            <span className="flex-1 truncate text-slate-700">{item.label}</span>
            <span className="text-slate-500 tabular-nums">{fmt(item.value)}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Donut
